// Import .less entry point
import '../assets/private/stylesheets/pages/pages/_homepage.less';
import './homepage/styles/style';

/** specific country imports */
import { init as initCountrySpecific } from '@/_override/homepage/homepage-country.entry';
import '@/_override/homepage/homepage-country.less';
/** end of specific country imports */

import './legacy/floors/cookies/cookies.legacy';

import { init as initSliders } from './homepage/homepage-sliders.entry';
import { init as initCartMerge } from './checkout/cart/cart-merge';

// Import analytics
import { init as initAnalytics } from './analytics/routes/homepage.anly.route';

document.addEventListener('DOMContentLoaded', () => {
  // Init Plugin CookieBanner
  $('#cookies-banner').UX_Cookies();

  // Init HP Sliders
  initSliders();

  // Cart merge
  initCartMerge();

  /** specific country  */
  initCountrySpecific();
  /** end of specific country */
  if ( window.cube.config.anly_useLegacy === 'Y') {
    initAnalytics();
  }
});



// WEBPACK FOOTER //
// ./src/homepage.route.js